import type {
  APIRequestBody,
  APIRequestQueryParams,
  APIResponse,
} from './base-fetch';
import { get, post } from './base-fetch';

export type SearchSuggestionQuery = APIRequestQueryParams<'/api/v4/search'>;
export type SearchSuggestionResponse = APIResponse<'/api/v4/search'>;
export type SearchSuggestion = SearchSuggestionResponse['results'][number];
export type SearchCountsQuery = APIRequestQueryParams<'/api/v4/search/counts'>;
export type SearchCountsResponse = APIResponse<'/api/v4/search/counts'>;

type Highlights = SearchSuggestion['highlights'];
export type HighlightKeys = keyof Highlights;

export const fetchSearchSuggestions = async (
  searchQuery: SearchSuggestionQuery,
) =>
  get<SearchSuggestionResponse>('/v4/search', {
    params: searchQuery,
  });

export const fetchSearchCounts = async (params: SearchCountsQuery) =>
  get<SearchCountsResponse>('/v4/search/counts', {
    params,
  });

export type SearchByNameQuery = APIRequestQueryParams<'/api/v4/search/by-name'>;
export type SearchByNameResponse = APIResponse<'/api/v4/search/by-name'>;
export type SimpleSearchSuggestion = SearchByNameResponse['results'][number];

export const fetchEntitiesByName = async (params: SearchByNameQuery) =>
  get<SearchByNameResponse>('/v4/search/by-name', {
    params,
  });

export type UserRecentSearchRecord =
  APIResponse<'/api/v4/search/user-recent-records'>[number];

export type AddUserRecentSearchRecordPayload =
  APIRequestBody<'/api/v4/search/user-recent-records/add'>;

export const fetchUserRecentSearchRecords = async () =>
  get<UserRecentSearchRecord[]>('/v4/search/user-recent-records');

export const addUserRecentSearchRecord = async (
  data: AddUserRecentSearchRecordPayload,
) =>
  post<UserRecentSearchRecord, AddUserRecentSearchRecordPayload>(
    '/v4/search/user-recent-records/add',
    data,
  );
